module.exports = __webpack_public_path__ + "media/images/discover-450aa8f9a5171be7e410eb76c22ab84c.svg";